/* Glue between the theme and the BSS B2B Solution app (dealer prices, VAT form, net terms).
   The theme itself notifies the app after every cart update (see theme.js); this file covers
   the first page load and the VAT form texts. */
(function () {
  function getBss() {
    return window.BSS_B2B;
  }

  function notifyCart() {
    try {
      getBss().observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');
    } catch (error) {
      /* app not loaded */
    }
  }

  function whenReady(test, callback, timeout) {
    var waited = 0;
    var timer = setInterval(function () {
      if (test()) {
        clearInterval(timer);
        callback();
      } else {
        waited += 200;
        if (waited >= (timeout || 5000)) clearInterval(timer);
      }
    }, 200);
  }

  var isCartPage = /\/cart\/?$/.test(window.location.pathname);

  if (isCartPage) {
    document.addEventListener('DOMContentLoaded', function () {
      whenReady(
        function () {
          return getBss() && getBss().observer && document.querySelector('[bss-b2b-final-line-price]');
        },
        function () {
          notifyCart();
          try {
            getBss().observer.cartSubject.listenCartCheckout();
          } catch (error) {
            /* older app version */
          }
        },
        4000
      );
    });
  }

  whenReady(
    function () {
      return getBss() && getBss().te && document.querySelector('.bss-b2b-vat-input-wrapper');
    },
    handleTEBox,
    10000
  );

  function handleTEBox() {
    const translations = BSS_B2B.te.teTranslations;
    const headerText = document.querySelector(
      ".bss-b2b-translation-vat-form_header_text"
    );
    if (headerText) {
      headerText.innerText = translations.form_header_text;
    }
  
    const subtitleText = document.querySelector(
      ".bss-b2b-translation-vat-form_subtitle_text"
    );
    if (subtitleText) {
      subtitleText.innerText = translations.form_subtitle_text;
    }
  
    const successMessages = [
      document.querySelector(".bss-b2b-translation-vat-form_success_message"),
      document.querySelector(".bss-b2b-translation-vat-form_success_message_uk"),
      document.querySelector(".bss-b2b-translation-vat-form_success_message_abn"),
      document.querySelector(".bss-b2b-translation-vat-form_success_message_gst"),
      document.querySelector(
        ".bss-b2b-translation-vat-form_success_message_us_ein"
      ),
    ];
  
    successMessages.forEach((msg, index) => {
      if (msg) {
        switch (index) {
          case 0:
            msg.innerText = translations.form_success_message || "";
            break;
          case 1:
            msg.innerText = translations.form_success_message_uk || "";
            break;
          case 2:
            msg.innerText = translations.form_success_message_abn || "";
            break;
          case 3:
            msg.innerText = translations.form_success_message_gst || "";
            break;
          case 4:
            msg.innerText = translations.form_success_message_us_ein || "";
            break;
        }
      }
    });
  
    const errorMessages = [
      document.querySelector(".bss-b2b-translation-vat-form_error_message"),
      document.querySelector(".bss-b2b-translation-vat-form_error_message_uk"),
      document.querySelector(".bss-b2b-translation-vat-form_error_message_abn"),
      document.querySelector(".bss-b2b-translation-vat-form_error_message_gst"),
      document.querySelector(
        ".bss-b2b-translation-vat-form_error_message_us_ein"
      ),
      document.querySelector(
        ".bss-b2b-translation-vat-form_validate_country_code_message"
      ),
    ];
  
    errorMessages.forEach((msg, index) => {
      if (msg) {
        switch (index) {
          case 0:
            msg.innerText = translations.form_error_message || "";
            break;
          case 1:
            msg.innerText = translations.form_error_message_uk || "";
            break;
          case 2:
            msg.innerText = translations.form_error_message_abn || "";
            break;
          case 3:
            msg.innerText = translations.form_error_message_gst || "";
            break;
          case 4:
            msg.innerText = translations.form_error_message_us_ein || "";
            break;
          case 5:
            msg.innerText = translations.form_validate_country_code_message || "";
            break;
        }
      }
    });
  }
})();
